module.exports = __webpack_public_path__ + "/images/cover-elige-compact-int-inline.807809e.svg";